import React, { useMemo, useState } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import { observer } from "mobx-react-lite";
import { ItemType } from "antd/es/menu/hooks/useItems";
import { MassEditButton } from "src/components/MassEdit/MassEditButton";
import { EntityFiltersPageStore } from "../../EntityFiltersPageStore";
import styles from "./EntityActions.module.less";
import { EntityExportButton } from "../EntityExportButton";
import { EntFilterActionType } from "../../EntityFiltersPage.types";
import { EntityCopyButton } from "../EntityCopyButton";
import { ChangeStateBulkButton } from "../ChangeStateBulkButton";
import { EntityImportButton } from "../EntityImportButton";
import { EntityMassDeleteButton } from "../EntityMassDeleteButton";

interface PropsEntityActions {
  store: EntityFiltersPageStore;
}

export const EntityActions: React.FC<PropsEntityActions> = observer(
  ({
    store,
    store: {
      currObjId,
      curObject,
      tableStore,
      currObjName,
      avalibleActionsSet,
      attributesMap,
      bsFuncs,
    },
  }) => {
    if (!currObjId || !tableStore) return null;
    const [loading, setLoading] = useState(false);

    const entityActionsMap: Partial<Record<EntFilterActionType, ItemType>> = {
      [EntFilterActionType.changeState]: {
        key: "stateChange",
        label: (
          <ChangeStateBulkButton
            tableStore={tableStore}
            objectId={currObjId}
            attributes={Object.values(attributesMap)}
            onLoad={setLoading}
          />
        ),
      },
      [EntFilterActionType.export]: {
        key: "export",
        label: (
          <EntityExportButton store={tableStore} objectName={currObjName} />
        ),
      },
      [EntFilterActionType.copy]: {
        key: "copy",
        label: (
          <EntityCopyButton
            tableStore={tableStore}
            objectId={currObjId}
            onLoad={setLoading}
          />
        ),
      },
      [EntFilterActionType.import]: {
        key: "import",
        label: (
          <EntityImportButton
            objectId={currObjId}
            objectName={curObject?.name}
            disabled={!curObject?.allowFileImport}
          />
        ),
      },
      [EntFilterActionType.massEdit]: {
        key: "massEdit",
        label: <MassEditButton store={store} />,
      },
    };
    if (curObject?.allowMassDelete) {
      entityActionsMap[EntFilterActionType.massDelete] = {
        key: "massDelete",
        label: <EntityMassDeleteButton tableStore={tableStore} />,
      };
    }

    const menuProps: MenuProps = useMemo(() => {
      const items = Object.entries(entityActionsMap)
        .filter(
          ([key, item]) =>
            avalibleActionsSet.has(key as EntFilterActionType) && !!item,
        )
        .map(([, item]) => [item, { type: "divider" } as ItemType])
        .flat();
      items.pop();

      // Добавить функции бизнес-сервиса
      bsFuncs.forEach((fn) => {
        items.push({ type: "divider" });
        items.push({
          key: `${fn.info.serviceKey}:${fn.functionName}`,
          label: fn.menuItem({
            name: fn.functionName,
            info: fn.info,
            entities: tableStore,
          }),
        });
      });
      return { items };
    }, []);

    if (!menuProps.items?.length) return null;

    return (
      <Dropdown menu={menuProps} placement="bottomRight">
        <Button
          id="entityListActions"
          icon={<MoreOutlined />}
          loading={loading}
          className={styles.menuButton}
        />
      </Dropdown>
    );
  },
);
